import { render, staticRenderFns } from "./ToolMiniDetail.vue?vue&type=template&id=660915c8&scoped=true"
import script from "./ToolMiniDetail.vue?vue&type=script&lang=js"
export * from "./ToolMiniDetail.vue?vue&type=script&lang=js"
import style0 from "./ToolMiniDetail.vue?vue&type=style&index=0&id=660915c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660915c8",
  null
  
)

export default component.exports